/**
 * PasswordRequirements - Visual password validation checklist
 */
import React from 'react';

function PasswordRequirements({ validation }) {
  const requirements = [
    { key: 'minLength', label: 'At least 8 characters' },
    { key: 'uppercase', label: 'One uppercase letter' },
    { key: 'number', label: 'One number' },
    { key: 'specialChar', label: 'One special character' },
  ];
  
  return (
    <div className="space-y-2 p-3 bg-gray-50 rounded-xl">
      <p className="text-xs font-medium text-gray-600 mb-2">Password requirements:</p>
      <ul className="space-y-1.5">
        {requirements.map(({ key, label }) => {
          const isPassed = validation?.details?.[key];
          
          return (
            <li
              key={key}
              className={`
                flex items-center gap-2 text-sm transition-colors
                ${isPassed ? 'text-green-600' : 'text-gray-500'}
              `}
            >
              {isPassed ? (
                <svg className="w-4 h-4 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              ) : (
                <svg className="w-4 h-4 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z" clipRule="evenodd" />
                </svg>
              )}
              {label}
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default PasswordRequirements;
